
import Vue, { PropType } from 'vue';
import { ValidationProvider } from 'vee-validate';
import { OptionsQuestion, QuestionType } from '@/config/types';
import RadioButton from '../RadioButton/index.vue';
import { Wrapper, Description, TextArea } from './styles';

export default Vue.extend({
  name: 'QuestionItem',
  components: {
    Wrapper,
    RadioButton,
    TextArea,
    ValidationProvider,
    Description,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    max: {
      type: Number,
      default: 4,
    },
    options: {
      type: Array as PropType<OptionsQuestion[]>,
      default: [],
    },
    questionType: {
      type: Number as PropType<QuestionType>,
      default: QuestionType.singleSelection,
    },
  },
  data() {
    return {
      choice: '',
      disabled: false,
    };
  },
  watch: {
    choice(newValue) {
      this.handleChange(newValue);
      this.disabled = true;
    },
  },
  methods: {
    handleChange(value: any) {
      this.$emit('choice', value);
    },
  },
  computed: {
    isObjectiveQuestion(): boolean {
      return (
        this.questionType === QuestionType.singleSelection
        || this.questionType === QuestionType.multipleChoice
        || this.questionType === QuestionType.onlyChoice
      );
    },
    isTextQuestion(): boolean {
      return this.questionType === QuestionType.text;
    },
  },
});
